import { SvgIcon } from "@mui/material";

export default function BeeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <defs>
        {/* Wing gradient - pearlescent */}
        <linearGradient id="wingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.95" />
          <stop offset="50%" stopColor="#E3F2FD" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#BBDEFB" stopOpacity="0.75" />
        </linearGradient>
        {/* Body yellow gradient */}
        <linearGradient id="yellowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FFD54F" />
          <stop offset="50%" stopColor="#FFCA28" />
          <stop offset="100%" stopColor="#FFD54F" />
        </linearGradient>
        {/* Dark stripe gradient */}
        <linearGradient id="stripeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#4E342E" />
          <stop offset="50%" stopColor="#3E2723" />
          <stop offset="100%" stopColor="#4E342E" />
        </linearGradient>
        {/* Highlight gradient for shine */}
        <linearGradient id="highlightGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>
      
      {/* Subtle drop shadow */}
      <ellipse cx="12" cy="21" rx="5" ry="1" fill="#000000" opacity="0.1" />
      
      {/* Secondary wings (smaller, behind main wings) */}
      <ellipse cx="7" cy="11.5" rx="2.5" ry="1.8" fill="url(#wingGradient)" stroke="#B3E5FC" strokeWidth="0.3" transform="rotate(-15 7 11.5)" opacity="0.7" />
      <ellipse cx="17" cy="11.5" rx="2.5" ry="1.8" fill="url(#wingGradient)" stroke="#B3E5FC" strokeWidth="0.3" transform="rotate(15 17 11.5)" opacity="0.7" />
      
      {/* Primary wings */}
      <g opacity="0.9">
        <ellipse cx="5.5" cy="10" rx="4.5" ry="3" fill="url(#wingGradient)" stroke="#90CAF9" strokeWidth="0.5" transform="rotate(-30 5.5 10)" />
        <path d="M4 9 Q5.5 10, 7 9.5" stroke="#B3E5FC" strokeWidth="0.3" fill="none" opacity="0.6" />
        <path d="M3.5 10.5 Q5.5 11, 7.5 10" stroke="#B3E5FC" strokeWidth="0.3" fill="none" opacity="0.6" />
        <ellipse cx="18.5" cy="10" rx="4.5" ry="3" fill="url(#wingGradient)" stroke="#90CAF9" strokeWidth="0.5" transform="rotate(30 18.5 10)" />
        <path d="M17 9.5 Q18.5 10, 20 9" stroke="#B3E5FC" strokeWidth="0.3" fill="none" opacity="0.6" />
        <path d="M16.5 10 Q18.5 11, 20.5 10.5" stroke="#B3E5FC" strokeWidth="0.3" fill="none" opacity="0.6" />
      </g>
      
      {/* Antennae */}
      <path d="M10.5 6 Q9.5 3.5, 8 2.5" stroke="#3E2723" strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M13.5 6 Q14.5 3.5, 16 2.5" stroke="#3E2723" strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <circle cx="8" cy="2.5" r="0.7" fill="#3E2723" />
      <circle cx="16" cy="2.5" r="0.7" fill="#3E2723" />
      
      {/* Head */}
      <circle cx="12" cy="7" r="2.8" fill="#3E2723" />
      
      {/* Rosy cheeks */}
      <circle cx="9.8" cy="7.8" r="0.6" fill="#E57373" opacity="0.4" />
      <circle cx="14.2" cy="7.8" r="0.6" fill="#E57373" opacity="0.4" />
      
      {/* Eyes */}
      <ellipse cx="10.8" cy="6.8" rx="1" ry="1.1" fill="#FAFAFA" />
      <ellipse cx="13.2" cy="6.8" rx="1" ry="1.1" fill="#FAFAFA" />
      <circle cx="11" cy="6.9" r="0.5" fill="#1A1A1A" />
      <circle cx="13.4" cy="6.9" r="0.5" fill="#1A1A1A" />
      <circle cx="10.7" cy="6.5" r="0.25" fill="#FFFFFF" />
      <circle cx="13.1" cy="6.5" r="0.25" fill="#FFFFFF" />
      
      {/* Body stripes */}
      <path d="M8.5 9.5 Q12 9, 15.5 9.5 L16 11 Q12 10.5, 8 11 Z" fill="url(#yellowGradient)" />
      <path d="M8 11 Q12 10.5, 16 11 L16.2 12.8 Q12 12.3, 7.8 12.8 Z" fill="url(#stripeGradient)" />
      <path d="M7.8 12.8 Q12 12.3, 16.2 12.8 L16.3 14.8 Q12 14.3, 7.7 14.8 Z" fill="url(#yellowGradient)" />
      <path d="M7.7 14.8 Q12 14.3, 16.3 14.8 L16 16.6 Q12 16.1, 8 16.6 Z" fill="url(#stripeGradient)" />
      <path d="M8 16.6 Q12 16.1, 16 16.6 L15 18.2 Q12 17.8, 9 18.2 Z" fill="url(#yellowGradient)" />
      <ellipse cx="12" cy="18.5" rx="2.2" ry="1.3" fill="url(#stripeGradient)" />
      
      {/* Body highlight/shine */}
      <path d="M9 10.5 Q10 10.2, 11 10.5 L10.8 11.2 Q10 11, 9.2 11.2 Z" fill="url(#highlightGradient)" />
      <path d="M9 13.5 Q10 13.2, 11 13.5 L10.8 14.2 Q10 14, 9.2 14.2 Z" fill="url(#highlightGradient)" />
      
      {/* Body outline */}
      <path d="M8.5 9.5 Q7.5 13, 8 16.5 Q9 19, 12 19.5 Q15 19, 16 16.5 Q16.5 13, 15.5 9.5 Q12 9, 8.5 9.5" 
            fill="none" stroke="#5D4037" strokeWidth="0.3" opacity="0.4" />
      
      {/* Legs */}
      <path d="M9 14 Q7.5 15, 7 16" stroke="#3E2723" strokeWidth="0.6" strokeLinecap="round" fill="none" />
      <path d="M15 14 Q16.5 15, 17 16" stroke="#3E2723" strokeWidth="0.6" strokeLinecap="round" fill="none" />
      <path d="M8.5 16 Q7 17, 6.5 18" stroke="#3E2723" strokeWidth="0.6" strokeLinecap="round" fill="none" />
      <path d="M15.5 16 Q17 17, 17.5 18" stroke="#3E2723" strokeWidth="0.6" strokeLinecap="round" fill="none" />
      
      {/* Stinger */}
      <path d="M12 19.5 L12 21" stroke="#4E342E" strokeWidth="0.7" strokeLinecap="round" />
    </SvgIcon>
  );
}
